require('../../modules/es6.reflect.get');
module.exports = require('../../modules/_core').Reflect.get;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/reflect/get.js
// module id = 798
// module chunks = 14